import React from 'react';
import fr from 'facet-rest';
import {
  defaultAccountCreationRequestSummaryFilters,
  getAccountCreationRequestSummaryFilters,
} from 'Overrides/AccountCreationRequest';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { pickFunction } from 'Helpers/Affordances';
import { addQuery, QueryVal } from 'Helpers/Query';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import useUserContext from 'Context/UserContext';
import View from './View';
import { useApexAdminPortalStateContext, useApexAdminPortalDispatchContext } from '../ApexAdminPortalContext';
import {
  setRefreshLink,
  refreshAccountRequests,
} from '../ApexAdminPortalActions';

const AccountRequestFiltering = () => {
  const { accountSummaryCollection } = useApexAdminPortalStateContext();
  const apexAdminPortalDispatch = useApexAdminPortalDispatchContext();
  const { householdSearch } = useSimpleHousehold();
  const { userResource } = useUserContext();
  const availableFilters = (accountSummaryCollection && householdSearch) ? (
    pickFunction(userResource, {
      [fr.relationships.default.name]: () => {
        return getAccountCreationRequestSummaryFilters(accountSummaryCollection, householdSearch);
      },
    })
  ) : [];
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'Account Request Filtering' });


  React.useEffect(() => {
    setRefreshLink(QueryVal('link'), apexAdminPortalDispatch);
  }, []);

  return (
    <View
      collection={accountSummaryCollection}
      onApplyFilters={(refreshLink) => {
        setRefreshLink(refreshLink, apexAdminPortalDispatch);
        addQuery({ link: refreshLink });
        refreshAccountRequests(refreshLink, apexAdminPortalDispatch)
          .catch(() => { /* Capture returned promise. Expecting getAccountRequests() to display errors internally. */ });
        logEvent('Clicked Apply Filters Button', { refreshLink });
      }}
      defaultFilters={defaultAccountCreationRequestSummaryFilters}
      availableFilters={availableFilters}
      amplitudeRootNodeProps={rootNodeProps}
    />
  );
};

export default AccountRequestFiltering;
